import { render, staticRenderFns } from "./AppTable.vue?vue&type=template&id=21db654b"
import script from "./AppTable.vue?vue&type=script&lang=ts"
export * from "./AppTable.vue?vue&type=script&lang=ts"
import style0 from "./AppTable.vue?vue&type=style&index=0&id=21db654b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports